

























































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import TextEllipsis from '@/modules/shared/components/shared/utils/TextEllipsisOld.vue'
import { UserBootUseCase } from '@/modules/user/use-cases/shared/user-boot.use-case'

@Component({
  components: { TextEllipsis }
})
export default class UserDropdown extends Vue {
  constructor(
    private readonly userBootUseCase: UserBootUseCase
  ) {
    super()
  }

  get user() {
    return this.userBootUseCase.user
  }

  get loading() {
    return this.userBootUseCase.isLoading
  }

  logOut() {
    return this.userBootUseCase.logOut()
  }
}
